import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { createFileRoute } from '@tanstack/react-router';

import { CreateReportButton } from '@/components/features/create-report';
import { InspectionSummary } from '@/components/features/inspection-summary';
import { ObservationLogs } from '@/components/features/observation-logs';

export const Route = createFileRoute(
    '/(auth)/projects/$projectVersionId/re-inspections/summary/',
)({
    component: Page,
    loader: ({ context, params }) => {
        context.queryClient.ensureQueryData(elektraAppQueryOptions.project.recapViewOptions({
            electricalProjectVersionId: params.projectVersionId,
        }));
    },
});

function Page() {
    const params = Route.useParams();
    const id = params.projectVersionId;

    return (
        <>
            <InspectionSummary electricalProjectVersionId={id} />

            <ObservationLogs electricalProjectVersionId={id} />

            <CreateReportButton electricalProjectVersionId={id} />
        </>
    );
}
